import { render, staticRenderFns } from "./PainelLancamentoProduto.vue?vue&type=template&id=0baf43e4&scoped=true&"
import script from "./PainelLancamentoProduto.vue?vue&type=script&lang=js&"
export * from "./PainelLancamentoProduto.vue?vue&type=script&lang=js&"
import style0 from "./PainelLancamentoProduto.vue?vue&type=style&index=0&id=0baf43e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf43e4",
  null
  
)

export default component.exports